/**
 * Create Bounded Context Handler
 * 
 * CQRS Command Handler that delegates to BoundedContextCommandService.
 * Thin adapter layer that transforms commands to application service calls.
 */

import { injectable, inject } from 'inversify';
import { ICommandHandler } from '@swoft/core';
import { CreateBoundedContextCommand } from '../commands/CreateBoundedContextCommand';
import { BoundedContextCommandService } from '../services/BoundedContextCommandService';
import { DDD_SYMBOLS } from '../../../../infrastructure/di/DDD_SYMBOLS';

@injectable()
export class CreateBoundedContextHandler implements ICommandHandler<CreateBoundedContextCommand, { boundedContextId: string }> {
  constructor(
    @inject(DDD_SYMBOLS.BoundedContextCommandService) private boundedContextCommandService: BoundedContextCommandService
  ) {}

  async handle(command: CreateBoundedContextCommand): Promise<{ boundedContextId: string }> {
    const result = await this.boundedContextCommandService.createBoundedContext(
      command.domainId,
      command.payload,
      command.authSessionId,
      command.initiatedByPersonId,
      command.correlationId
    );
    
    return { 
      boundedContextId: result.boundedContextId 
    };
  }
}